// extracted by mini-css-extract-plugin
export default {"placeholder":"Input_placeholder__Fnxpy","inputWrapper":"Input_inputWrapper__w2QyB","inputContainer":"Input_inputContainer__N5eCc","input":"Input_input__eXwaT"};